import { render, staticRenderFns } from "./CourseManageView.vue?vue&type=template&id=0920c310&scoped=true"
import script from "./CourseManageView.vue?vue&type=script&lang=js"
export * from "./CourseManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920c310",
  null
  
)

export default component.exports